import { render, staticRenderFns } from "./TestimonialCardRounded.vue?vue&type=template&id=7224c23f&scoped=true&"
import script from "./TestimonialCardRounded.vue?vue&type=script&lang=ts&"
export * from "./TestimonialCardRounded.vue?vue&type=script&lang=ts&"
import style0 from "./TestimonialCardRounded.vue?vue&type=style&index=0&id=7224c23f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7224c23f",
  null
  
)

export default component.exports